import { jsx as _jsx } from "react/jsx-runtime";
import _ from 'lodash';
import React, { createContext, useContext, useEffect, useState } from 'react';
import { CUSTOMER_PORTAL_PREVIEW } from 'hooks/use-customer-preview';
import { useQueryParamsFromWindow } from 'hooks/use-query-params';
const customerPortalContext = /*#__PURE__*/ createContext({
    isLoading: true,
    isPreviewAvailable: false,
    setLoading: ()=>{},
    setPreview: ()=>{},
    setProjectId: ()=>{},
    setPortalId: ()=>{}
});
export const useCustomerPreviewForCustomerPortalV2 = ()=>useContext(customerPortalContext);
export const CustomerPortalPreviewProvider = ({ children })=>{
    const [isLoading, setLoading] = useState(true);
    const [isPreviewAvailable, setPreview] = useState(false);
    const [projectId, setProjectId] = useState(null);
    const [portalId, setPortalId] = useState(null);
    const queryParams = useQueryParamsFromWindow();
    useEffect(()=>{
        const preview = queryParams.get(CUSTOMER_PORTAL_PREVIEW);
        const projectIdStr = queryParams.get('project');
        const portalIdStr = queryParams.get('portal');
        if (preview !== null && projectIdStr !== null && isLoading && portalIdStr) {
            const _isPreview = preview === 'true';
            const _projectId = parseInt(projectIdStr, 10);
            const _portalId = parseInt(portalIdStr, 10);
            const isProjectIdValid = _.isFinite(_projectId);
            if (_isPreview && isProjectIdValid) {
                setProjectId(_projectId);
                setPortalId(_portalId);
                setPreview(true);
                setLoading(false);
            }
        } else if (isLoading !== false) {
            setLoading(false);
        }
    }, [
        isLoading,
        queryParams
    ]);
    return /*#__PURE__*/ _jsx(customerPortalContext.Provider, {
        value: {
            isLoading,
            isPreviewAvailable,
            setLoading,
            setPreview,
            setProjectId,
            projectId,
            portalId,
            setPortalId
        },
        children: children
    });
};
